<template>
<div class="chapter">
<div class="inner_page">
<h1>Sommario</h1>
<p><span href="#/c001" title="Link target outside of Sample">Titolo Pagina</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Pagina</span></p>
<p><a href="#/c003">Gli 11 Migliori Allenamenti Cardio Per Bruciare il Grasso, Tonificare e Perdere Peso</a></p>
<p><span href="#/c004" title="Link target outside of Sample">frequenza cardiaca massima = 208 - (0,7 x età in anni)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?c9129754